import React from "react"
import type { ChakraProps } from "@chakra-ui/react"
import { Text } from "@chakra-ui/react"
import type { ProductAvailabilityType } from "types"
import { useUser } from "lib/user"
import { DiamondIcon, PieIcon } from "../SvgIcons"
import { colours } from "@shared/ui.design-system"

type Props = ChakraProps & {
  availability?: ProductAvailabilityType
}

export const ProductCardLabel: React.FC<Props> = ({
  availability,
  ...chakraProps
}) => {
  const user = useUser()

  if (!availability) return null
  const { label, status } = availability

  if (
    status === "outofstock" &&
    !label?.toLowerCase()?.includes("coming soon")
  ) {
    return (
      <Text variant="availabilityGrey" {...chakraProps}>
        OUT OF STOCK
      </Text>
    )
  }
  if (!label?.length) return null
  if (label === "Treasure Hunt" && (status !== "instock" || !user.isLoggedIn))
    return null
  if (label?.toLowerCase().includes("bonus day") && !user.isLoggedIn)
    return null

  const mapLabelToComponent: Record<string, null | JSX.Element> = {
    "In Stock": null, // this is the way to ignore labels
    "New In": (
      <Text variant="availabilityWhite" {...chakraProps}>
        New In!
      </Text>
    ),

    "Back In Stock": (
      <Text variant="availabilityPink" {...chakraProps}>
        Back in stock
      </Text>
    ),

    "Limited Stock": (
      <Text variant="availabilityPink" {...chakraProps}>
        Limited Stock
      </Text>
    ),

    "Limited Quantity Available": (
      <Text variant="availabilityPink" {...chakraProps}>
        Limited Stock
      </Text>
    ),

    "Coming Soon": (
      <Text variant="availabilityWhite" {...chakraProps}>
        Coming Soon
      </Text>
    ),

    "New In - Limited Stock": (
      <Text variant="availabilityPink" {...chakraProps}>
        New In - Limited
      </Text>
    ),

    "Last Call": (
      <Text variant="availabilityPink" {...chakraProps}>
        Last Call
      </Text>
    ),

    "Limited Edition": (
      <Text variant="availabilityPink" {...chakraProps}>
        Limited Edition
      </Text>
    ),

    "BONUS DAY!": (
      <Text variant="availabilityPink" {...chakraProps}>
        BONUS DAY!
      </Text>
    ),

    Pieday: (
      <Text variant="pieDay" {...chakraProps}>
        PieDay <PieIcon color={colours.accent.strong} boxSize="1.5rem" />
      </Text>
    ),

    "Find The Pie": (
      <Text variant="pieDayIcon" {...chakraProps}>
        <PieIcon color={colours.accent.strong} boxSize="1.5rem" />
      </Text>
    ),
    "Treasure Hunt": (
      <Text variant="treasureHunt" {...chakraProps}>
        <DiamondIcon w="20px" h="20px" />
      </Text>
    ),
  }

  return mapLabelToComponent[label] !== undefined ? (
    mapLabelToComponent[label]
  ) : (
    <Text variant="availabilityWhite" {...chakraProps}>
      {label}
    </Text>
  )
}
